/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import classNames from 'classnames/bind'
import { Text } from 'hocs/localization'
import { REGISTRATION_STEPS } from 'constants/auth'
import * as styles from './CreateProfileProgress.scss'

const cx = classNames.bind(styles)

interface IProps {
  step: string,
  t: Text
}

const isActive = (step, item, i) => {
  const activeNum = step ? Object.values(REGISTRATION_STEPS).indexOf(step) : 0
  return i <= activeNum
}

const CreateProfileProgress: React.SFC<IProps> = ({ step, t }) => (
  <div className='col-md-12'>
    <div className={styles.CreateAccountTitle}>
      <ul>
        {Object.values(REGISTRATION_STEPS).map((item, i) => (
          <li className={cx({ active: isActive(step, item, i) })} key={i}>
            <span className={styles.stepNum}>{i + 1}</span>
            <span>{t(item)}</span>
          </li>
        ))}
      </ul>
    </div>
  </div>
)

export default CreateProfileProgress
